import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from '@tanstack/react-query';
import { ProjectAPI } from 'api/project';
import { GENERAL_API_STALE } from 'config/query-config';
import { DEFAULT_SQUAD, SquadContext } from 'contexts/squad';
export const SquadProvider = (props)=>{
    const { children, projectId } = props;
    const { data, isLoading } = useQuery([
        'project-members',
        projectId
    ], ()=>{
        return ProjectAPI.getMembers(projectId);
    }, {
        staleTime: GENERAL_API_STALE
    });
    return /*#__PURE__*/ _jsx(SquadContext.Provider, {
        value: data || DEFAULT_SQUAD,
        children: !isLoading && children
    });
};
